module.exports = __webpack_public_path__ + "static/media/ResumeTemplate.8234cab5.png";